import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { ConfirmationModel, ConfirmationStoreModel } from './confirmation.model';

import {
  getHours,
  setHours,
  getMinutes,
  setMinutes,
  addMinutes
 } from 'date-fns';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { APPOINTMENT_REQUEST } from '../../actions/appointment.action';
import { Booking, BOOKING_REQUEST } from '../../actions/booking.action';
import { Info } from '../../actions/info.action';
import { DATA_REQUEST, Data } from '../../actions/data.action';
import { SHOW_HEADER } from '../../actions/header.action';
import { State } from '../../reducers/index';

@Component({
  selector: 'consentz-confirmation',
  templateUrl: './confirmation.template.html',
  styleUrls: ['./confirmation.styles.scss']
})
export class ConfirmationComponent implements OnInit, OnDestroy {
  public model: ConfirmationModel = new ConfirmationModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1],
    JSON.parse(localStorage.getItem('settings')).takePaymentForExistingPatients,
    JSON.parse(localStorage.getItem('settings')).takePaymentForNewPatients
  );
  public storeData: ConfirmationStoreModel = new ConfirmationStoreModel();
  public settings = JSON.parse(localStorage.getItem('settings')).type;

  constructor(
    private router: Router,
    private store: Store<State>,
    private cdr: ChangeDetectorRef
  ) {
    // hide header, get appointments request
    this.store.dispatch({ type: SHOW_HEADER });
    this.store.dispatch({
      type: DATA_REQUEST,
      payload: {
        requestUrl: `/online-booking/appointments`
      }
    });
    this.store.dispatch({
      type: BOOKING_REQUEST,
      payload: {
        requestUrl: '/settings'
      }
    });
    // subscribtion for widget options, server data, local selections
    this.storeData.subscribtion.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
      if (data['settings']) {
        this.settings = data['settings'].type;
        this.model.permissionForConfirmationWithoutPaymentForExistingPatients = data['settings'].takePaymentForExistingPatients;
        this.model.permissionForConfirmationWithoutPaymentForNewPatients = data['settings'].takePaymentForNewPatients;
      }
      // this.update();
    });
    this.storeData.subscribtion.data$ = store.select<any>('data').subscribe((data: Data) => {
      this.model.currentUserAppointments = data['appointments'];
      // this.update();
    });
    this.storeData.subscribtion.info$ = store.select<any>('info').subscribe((data: Info) => {
    this.model.currentUserInfoDataForPreview = data;
      const date = setMinutes(setHours(new Date(data['date']), +data['userLocalTime'].value.split(':')[0]), +data['userLocalTime'].value.split(':')[1]);
      this.model.currentUserInfoDataForPreview.timeEnd = `${getHours(addMinutes(date, data['treatment'].defaultLength))}:` + `${getMinutes(addMinutes(date, data['treatment'].defaultLength)) < 10 ?
      '0' + getMinutes(addMinutes(date, data['treatment'].defaultLength)) : getMinutes(addMinutes(date, data['treatment'].defaultLength))}`;
    });
    window.dispatchEvent(new Event('resize'));
  }

  // check current user login and set appointment registration
  public checkUser(): void {
    this.router.navigate([this.model.widgetIdForRouting + (localStorage.getItem('currentUser') ? '/time' : '/details')]);
  }

  // check permission and set appointment registration
  public createAppointment(): void {
    // it's the way to register appointment to user if we don't have permission for payments
    if (JSON.parse(localStorage.getItem('Appointment')).totalCost === '0.00') {
      this.router.navigate([this.model.widgetIdForRouting + '/confirmed']);
    }
    if (
      (this.model.permissionForConfirmationWithoutPaymentForExistingPatients && this.model.currentUserAppointments && this.model.currentUserAppointments.length > 0) ||
      (this.model.permissionForConfirmationWithoutPaymentForNewPatients && this.model.currentUserAppointments && this.model.currentUserAppointments.length === 0) ||
      (this.model.permissionForConfirmationWithoutPaymentForNewPatients && this.model.permissionForConfirmationWithoutPaymentForExistingPatients)
    ) {
        this.router.navigate([this.model.widgetIdForRouting + '/payment']);
        this.model.currentUserInfoDataForPreview.confirmation = true;
      }
    this.store.dispatch({
      type: APPOINTMENT_REQUEST,
      payload: this.model.currentUserInfoDataForPreview
    });
  }

  public ngOnInit(): void {
    this.model.changeDetectorRefTimeout = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }
  // unsubscribe from store
  public ngOnDestroy(): void {
    clearTimeout(this.model.changeDetectorRefTimeout);
    this.storeData.subscribtion.booking$.unsubscribe();
    this.storeData.subscribtion.info$.unsubscribe();
    this.storeData.subscribtion.data$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/confirmation/confirmation.component.ts